import { lazy } from "react";

const MainPage = lazy(() => import("./index.js"));

const routes = [
  {
    path: "/dashboard/medical-attention",
    exact: true,
    name: "Atención Médica de Dispensarios",
    component: MainPage
  }
];

export default routes;
